<template lang="html">
  <div class="">

    <Row :gutter="20">
      <Col :span="8">
        <!-- <h2>Saldo ad oggi</h2> -->
        <div class="saldo-ad-oggi" v-if="saldi" style="">
          <!-- {{ saldi }} -->
          <Row :gutter="20">
            <Col :span="24">
              <b>Saldi fine mese {{ saldi.year }}:</b>&nbsp;&nbsp;
              <Select v-model="saldi_show">
                <Option v-for="(stats, i) in saldi.data" :value="i" :key="i">{{ $d(Date.maintain('2018-'+(i+1)+'-01'), 'justmonth') }}</Option>
              </Select>
              <!-- <pre>{{ saldi.current }}</pre> -->
              <div v-if="ssss = saldi.data[saldi_show]" class="ivu-table spaced" style="margin: 1em 0 ">
                <table>
                  <thead>
                    <tr>
                      <th rowspan=1 style="">Conto</th>
                      <th colspan=1 class="text-right" style="">Entrate</th>
                      <th colspan=1 class="text-right" style="">Uscite</th>
                      <th colspan=1 class="text-right" style="">Saldo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- quacc -->
                    <tr v-for="led in ssss">
                      <td>
                        [{{led.code}}] {{ led.name }}
                      </td>
                      <td class="text-right entrate">
                        {{ $n(led.dare, 'currency') }}
                      </td>
                      <td class="text-right uscite">
                        {{ $n(led.avere, 'currency') }}
                      </td>
                      <td class="text-right">
                        <b>{{ $n(led.saldo, 'currency') }}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
            <!-- <Col :span="14">
              <div style="margin-left: 200px; margin-top: 30px; font-weight: bold">
                Saldi mensili anno {{ saldi.year }}:
              </div>

              <GChart
              type="ColumnChart"
              :data="[
              ['Mese'].concat(saldi.data[0].map(s => s.code))
              ].concat(saldi.data.map((v, i) => [
              $d(Date.maintain('2018-'+(i+1)+'-01'), 'justmonth')
              ].concat(v.map(s => s.saldo))))"
              />
            </Col> -->
          </Row>
        </div>
      </Col>
      <Col :span="8">
        &nbsp;
      </Col>
      <Col :span="8">
        <AlertTroppaIVA :year="year"/>
      </Col>
    </Row>
    <br>
    <br>
    <!-- <ButtonGroup> -->
      <h2>Aggiungi:</h2>
      <Dropdown>
        <Button type="success">
          Entrate
          <Icon type="arrow-down-b"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem :disabled="!ledgers" @click.native="createCustom('entrata-cassa')">
            In cassa
          </DropdownItem>
          <DropdownItem :disabled="!ledgers" @click.native="createCustom('entrata-banca')">
            In banca
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Dropdown>
        <Button type="error">
          Uscite
          <Icon type="arrow-down-b"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem :disabled="!ledgers" @click.native="createCustom('uscita-cassa')">
            Da cassa
          </DropdownItem>
          <DropdownItem :disabled="!ledgers" @click.native="createCustom('uscita-banca')">
            Da banca
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!-- <Button type="default" :disabled="!ledgers" @click.native="$root.$emit('invoice.show', {is_a:'ric', items: [{
        ledger_id: ledgers.find(l => l.code==630).id
        }]})">
        Erogazione liberale
      </Button> -->
      <Button @click.native="$root.$emit('invoice.show', {is_a:'ric'})" type="info" class="ivu-btn-purple">
        <Icon type="plus"></Icon>
        Ricevuta
      </Button>
      <Button @click.native="$root.$emit('invoice.show', {is_a:'inv'})" type="info">
        <Icon type="plus"></Icon>
        Fattura
      </Button>
      <Button @click.native="$root.$emit('invoice.show', {is_a:'nacc'})" type="error">
        <Icon type="plus"></Icon>
        Nota di credito
      </Button>
      <Dropdown>
        <Button type="warning">
          Movimento finanziario
          <Icon type="arrow-down-b"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem :disabled="!ledgers" @click.native="createCustom('cassa-a-banca')">
            Da cassa a banca
          </DropdownItem>
          <DropdownItem :disabled="!ledgers" @click.native="createCustom('banca-a-cassa')">
            Da banca a cassa
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button @click.native="createCustom('uso-buoni')">Utilizzo buoni spesa</Button>
      <Button v-if="$store.company.has_partita_doppia" @click.native="tx_form = {}">Movimento in partita doppia</Button>
    <!-- </ButtonGroup> -->





    <br>
    <br>
    <h2>Filtri:</h2>
    <Row :gutter="16" v-if="txs && txs.filters">
      <Col style="min-width: 140px" :md="1">
        Data <br>
        <LocalDate v-model="filters.date"/>
      </Col>
      <Col style="min-width: 140px" :md="1">
        Periodo:<br>
        <Select v-model="filters.period" style="max-width: 100px">
          <!-- <Option :value="''">Tutti</Option> -->
          <template v-for="year in txs.filters.years">
            <Option :key="year" :value="''+year"><b>Intero {{ year }}</b></Option>
            <Option v-for="month in txs.filters.months.filter(m => m.substring(0, 4) == year)" :key="month" :value="month">{{ $d(new Date(month), 'month') }}</Option>
          </template>
        </Select>
      </Col>
      <Col style="min-width: 200px" :md="1">
        Categoria <br>
        <Select v-model="filters.category" style="max-width: 140px" filterable clearable>
          <Option :value="''">Tutte</Option>
          <Option v-for="cat in txs.filters.categories" :key="cat" :value="cat">{{ cat }}</Option>
        </Select>
      </Col>
      <Col style="min-width: 200px" :md="1">
        Descrizione <br>
        <Select v-model="filters.causal" style="max-width: 140px" filterable clearable>
          <Option :value="''">Tutte</Option>
          <Option v-for="cat in txs.filters.causals" :key="cat" :value="cat">{{ cat }}</Option>
        </Select>
      </Col>
      <Col style="min-width: 200px" :md="1">
        Movimentazione conto <br>
        <LedgerSelect v-model="filters.ledger_id" :ledgers="ledgers"/>
      </Col>
      <Col style="min-width: 200px" :md="4">
        <b>Esporta i dati qui sotto:</b> <br>

        <Button
          @click="_download = 'xls'; refreshTxs()"
          :loading="down_load['xls']"
          type="primary"
          style="display: inline-block; margin-right: 5px">
          <Icon type="android-download"/>
          Excel
        </Button>
        <Button
          @click="_download = 'pdf'; refreshTxs()"
          :loading="down_load['pdf']"
          type="primary"
          style="display: inline-block; margin-right: 5px">
          <Icon type="android-download"/>
          PDF
        </Button>
      </Col>
    </Row>


    <div class="ivu-table spaced" style="margin: 1em 0; ;">
      <table>
        <thead>
          <tr>
            <th rowspan=2 style="width: 100px; cursor: pointer" @click="orderBy('date')">
              Data
              <Icon v-if="order && order.by=='date'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
            <th rowspan=2 style="">Tipologia movimento</th>
            <th rowspan=2 style="width: 130px">Conti</th>
            <th rowspan=2 style="width: 100px">Importo</th>
            <th colspan=2 style="text-align: center; width: 150px">Cassa</th>
            <th colspan=2 style="text-align: center; width: 150px">Banca</th>
          </tr>
          <tr>
            <th style="text-align: center; cursor: pointer;" @click="orderBy('entrate_c')">
              Entrate
              <Icon v-if="order && order.by=='entrate_c'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
            <th style="text-align: center; cursor: pointer;" @click="orderBy('uscite_c')">
              Uscite
              <Icon v-if="order && order.by=='uscite_c'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
            <th style="text-align: center; cursor: pointer;" @click="orderBy('entrate_b')">
              Entrate
              <Icon v-if="order && order.by=='entrate_b'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
            <th style="text-align: center; cursor: pointer;" @click="orderBy('uscite_b')">
              Uscite
              <Icon v-if="order && order.by=='uscite_b'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
          </tr>
        </thead>
        <tbody style="">
          <tr v-if="loading || !txs || !txs.data">
            <td colspan=3>
              Caricamento...
            </td>
          </tr>
          <tr v-else-if="!txs.data.length">
            <td colspan=3>
              Nessuna transazione trovata
            </td>
          </tr>
          <template v-else v-for="t in txs.data">
            <tr :key="t.id">
              <td>
                {{ $d(Date.maintain(t.date)) }}
              </td>
              <td>
                <Tooltip content="Elimina" placement="top">
                  <Icon @click="deleteTx(t)" type="ios-trash" style="color: var(--error-color); cursor:pointer;"/>
                </Tooltip>
                &nbsp;
                <span v-if="t.type=='tx'">
                  <a @click="createCustom(null, t)">Movimento </a>
                  &nbsp;
                  <i>
                    {{ t.category }}
                    <i v-if="t.associate_subscription">{{ t.associate_subscription.associate.full_name }} {{ t.associate_subscription.associate.deleted_at }}</i>
                  </i>
                </span>
                <span v-else-if="t.type=='inv.rec' && t.invoice">
                  <a @click="$root.$emit('invoice.show', t.invoice)">
                    <span v-if="t.invoice.is_a=='inv'">Fattura ricevuta</span>
                    <span v-if="t.invoice.is_a=='ric'">Ricevuta da cliente</span>
                    <span v-if="t.invoice.is_a=='nacc'">Nota di credito da cliente</span>
                  </a>
                  &nbsp;
                  <i>
                    <Tooltip style="border-bottom: 1px solid #ccc;" content="Protocollo" placement="top" v-if="t.invoice.protocol">P.{{ t.invoice.protocol }}</Tooltip>
                    &nbsp;
                    <Tooltip style="border-bottom: 1px solid #ccc;" content="Numero documento" placement="top" v-if="t.invoice.number">N.{{ t.invoice.number }}</Tooltip>
                    &nbsp;
                    da <b>{{ t.invoice.contact_name }}</b>
                    <!-- <span v-if="t.invoice.notes"> {{ t.invoice.notes }}</span> -->
                  </i>
                </span>
                <span v-else-if="t.type=='inv.sent' && t.invoice">
                  <Tooltip content="Stampa" placement="top">
                    <a v-if="t.invoice.is_a=='ric'" style="color:#555;" @click="$utils.print('print-ric/'+t.invoice.id)">
                      <Icon type="ios-printer"/>&nbsp;
                    </a>
                  </Tooltip>

                  <a @click="$root.$emit('invoice.show', t.invoice)">
                    <span v-if="t.invoice.is_a=='inv'">Fattura emessa</span>
                    <span v-if="t.invoice.is_a=='ric'"> Ricevuta emessa </span>
                    <span v-if="t.invoice.is_a=='nacc'"> Nota di credito emessa </span>
                  </a>
                  &nbsp;
                  <i>
                    <Tooltip style="border-bottom: 1px solid #ccc;" content="Protocollo" placement="top" v-if="t.invoice.protocol">P.{{ t.invoice.protocol }}</Tooltip>
                    &nbsp;
                    <Tooltip style="border-bottom: 1px solid #ccc;" content="Numero documento" placement="top" v-if="t.invoice.number">N.{{ t.invoice.number }}</Tooltip>
                    &nbsp;
                    per <b>{{ t.invoice.contact_name }}</b>
                    <!-- <span v-if="t.invoice.notes"> {{ t.invoice.notes }}</span> -->
                  </i>
                </span>
                <span v-else-if="t.type=='pay.sent' && t.invoice_payment">
                  <a @click="$root.$emit('invoice.show', t.invoice_payment.invoice)">Pagamento inviato</a>
                  &nbsp;
                  <i>
                  <Tooltip style="border-bottom: 1px solid #ccc;" content="Protocollo" placement="top" v-if="t.invoice_payment.invoice.protocol">P.{{ t.invoice_payment.invoice.protocol }}</Tooltip>
                  &nbsp;
                  <Tooltip style="border-bottom: 1px solid #ccc;" content="Numero documento" placement="top" v-if="t.invoice_payment.invoice.number">N.{{ t.invoice_payment.invoice.number }}</Tooltip>
                  &nbsp;
                    a <b>{{ t.invoice_payment.invoice.contact_name }}</b>
                    {{ t.invoice_payment.invoice.notes }}
                  </i>
                </span>
                <span v-else-if="t.type=='pay.rec' && t.invoice_payment">
                  <a @click="$root.$emit('invoice.show', t.invoice_payment.invoice)">Pagamento ricevuto</a>
                  &nbsp;
                  <i>
                  <Tooltip style="border-bottom: 1px solid #ccc;" content="Protocollo" placement="top" v-if="t.invoice_payment.invoice.protocol">P.{{ t.invoice_payment.invoice.protocol }}</Tooltip>
                  &nbsp;
                  <Tooltip style="border-bottom: 1px solid #ccc;" content="Numero documento" placement="top" v-if="t.invoice_payment.invoice.number">N.{{ t.invoice_payment.invoice.number }}</Tooltip>
                  &nbsp;
                    da <b>{{ t.invoice_payment.invoice.contact_name }}</b>
                    {{ t.invoice_payment.invoice.notes }}
                  </i>
                </span>
                <span v-else>{{ t.type }}</span>
                <span v-if="t.causal"> - {{ t.causal }}</span>
              </td>
              <td>
                <template v-for="line in t.lines">
                  <Tooltip :content="line.ledger.name + ': ' + $n(line.amount, 'currency')" placement="top">
                    <Tag :color="line.amount > 0 ? 'blue' : 'red'" type="border" class="wollotag">{{ line.ledger.code }}</Tag>
                  </Tooltip>
                </template>
              </td>
              <td style="text-align: center;" class="text-info">
                <span v-if="sum = _.sum(t.lines.map(e => e.amount > 0 ? e.amount : 0))">{{ $n(sum, 'currency') }}</span>
                <span v-else>--</span>
              </td>
              <td style="text-align: center;" class="entrate">
                <span v-if="(ss=saldoFor(t, /^CAS/)) > 0">{{ $n(ss, 'currency') }}</span>
                <span v-else>--</span>
              </td>
              <td style="text-align: center;" class="uscite">
                <span v-if="ss < 0">{{ $n(-ss, 'currency') }}</span>
                <span v-else>--</span>
              </td>
              <td style="text-align: center;" class="entrate">
                <span v-if="(ss=saldoFor(t, /^B/)) > 0">{{ $n(ss, 'currency') }}</span>
                <span v-else>--</span>
              </td>
              <td style="text-align: center;" class="uscite">
                <span v-if="ss < 0">{{ $n(-ss, 'currency') }}</span>
                <span v-else>--</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <!-- <Spin size="large" fix v-if="loading"/> -->
    </div>

    <div class="text-center" v-if="txs && txs.last_page > 1">
      <Page
      style="margin: 1em 0"
      :current="txs.current_page"
      :total="txs.total"
      :page-size="txs.per_page"
      @on-change="refreshTxs"/>
    </div>

    <Modal v-model="show_tx_form" class-name="no-foot">
      <TxForm v-if="show_tx_form" :filters="txs.filters || {}" @close="show_tx_form=null" @saved="refreshTxs()" :tx="tx_form"/>
    </Modal>

    <Modal v-model="show_custom" class-name="no-foot">
      <Form v-if="custom" ref="custom" :model="custom.form"
      @submit.native.prevent="saveCustom()"
      :label-width="120">
        <div ref="custom_focus">
          <FormItem>
            <h3>{{ custom.form.category }}</h3>
          </FormItem>
          <FormItem prop="causal" label="Descrizione">
            <AutoComplete
                v-model="custom.form.causal"
                :data="[]"
                :filter-method="autofilter"
                placeholder="Descrizione"
                icon="ios-pricetags"
                >
            </AutoComplete>
          </FormItem>
          <FormItem :rules="req" prop="date" label="Data">
            <LocalDate v-model="custom.form.date"/>
          </FormItem>
          <FormItem :rules="reqlt0" prop="lines.1.amount" label="Importo">
            <NumInput icon="cash" :value="cfl[1].amount || ''" @input="cfl[0].amount = - (cfl[1].amount = $event)"/>
          </FormItem>
          <FormItem v-if="cfl[0].select" :rules="reqlt0" prop="lines.0.ledger_id" :label="cfl[0].label || 'Conto'">
            <!-- {{ cfl[0].ledger_id}} -->
            <!-- {{ cfl[0].select}} -->
            <LedgerSelect v-model="cfl[0].ledger_id" :ledgers="cfl[0].select"/>
          </FormItem>
          <FormItem v-if="cfl[1].select" :rules="reqlt0" prop="lines.1.ledger_id" :label="cfl[1].label || 'Conto'">
            <LedgerSelect v-model="cfl[1].ledger_id" :ledgers="cfl[1].select"/>
          </FormItem>
          <FormItem>
            <Button :loading="custom.saving" html-type="submit">Salva</Button>
          </FormItem>
          <FormItem>
          </FormItem>
          <!-- <pre>{{ custom.form }}</pre> -->
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
import TxForm from './tx-form'
// import inViewport from 'vue-in-viewport-mixin';
import AlertTroppaIVA from './alert-troppa-iva';

export default {
  // mixins: [ inViewport ],

  components: {
    TxForm,
    AlertTroppaIVA,
  },

  data () {
    var month = new Date()
    month.setDate(1)
    month = month.serializeLocal()
    return {
      internal_page: 0,
      internal_offset: 0,
      loading: true,
      txs: {data:[]},
      current_month: month,
      filters: {
        company_id: this.$store.company.id,
        period: (new Date).getFullYear(),
        ledger_id: null,
      },
      tx_form: null,
      custom: null,
      ledgers: null,
      order: {
        by: 'date',
        asc: false,
      },
      year: (new Date).getFullYear(),
      saldi: null,
      saldi_show: (new Date).getMonth(),
      export_period: (new Date()).getFullYear(),
      contab_years: [(new Date()).getFullYear()],
      _download: null,

      down_load: {},

      cats: {
        'cassa-a-banca': 'Trasferimento da cassa a banca',
        'banca-a-cassa': 'Trasferimento da banca a cassa',
        'entrata-cassa': 'Entrata in cassa',
        'entrata-banca': 'Entrata in banca',
        'uscita-cassa': 'Uscita da cassa',
        'uscita-banca': 'Uscita da banca',
        'uso-buoni': 'Utilizzo buoni spesa',
      },
    }
  },

  mounted () {
    window.pn = this
    this.refreshTxs()
    this.refreshLedgers()
    this.$root.$on('invoices', this.refreshTxs)
    this.$root.$on('transactions', this.refreshTxs)
    this.$http.get('contab-years?company_id=' + this.$store.company.id).then(res => {
      this.contab_years = res.data.map(y => parseInt(y))
    })
  },
  beforeDestroy() {
    this.$root.$off('invoices', this.refreshTxs)
    this.$root.$off('transactions', this.refreshTxs)
  },

  methods: {
    saldoFor(tx, test) {
      if (!tx.__tmp) this.$set(tx, '__tmp', {})
      else if (tx.__tmp[''+test]) return tx.__tmp[''+test]

      var res = tx.lines.find(el => el.ledger.code.match(test))
      res = res ? res.amount : null
      tx.__tmp[''+test] = res
      return res
    },

    refreshTxs(page) {
      if (page !== undefined) {
        this.page = page
      }
      console.error('refreshing', page)
      var params = Object.assign({
        page: this.page || 1,
      }, this.filters)

      if (('' + params.period).length == 4) {
        params.year = params.period
      } else {
        params.month = params.period
      }

      if (this._download) {
        params.download = this._download

        this.$set(this.down_load, params.download, true)
        this.$utils.download('prima-nota.'+this._download, 'transactions', params, () => {
          this.down_load[params.download] = false
        })
        this._download = null
        return
      }

      params.order = this._.clone(this.order)
      if (params.order) {
        params.order.asc*= 1
      }


      this.loading = true
      this.$http.get('transactions', {params}).then(res => {
        var txs = res.data
        if (!txs.filters.months.includes(this.current_month)) {
          txs.filters.months.push(this.current_month)
          txs.filters.months = txs.filters.months.sort().reverse()
        }
        let d = txs.data
        txs.data = null
        this.txs = txs
        setTimeout(() => {console.log('start draw'); txs.data = d}, 0)


        // let data = txs.data.reverse()
        // txs.data = []
        // this.txs = txs
        //
        // let int = setInterval(() => {
        //   let row = data.pop()
        //   console.log('----------', row, txs.data)
        //   if (!row) clearInterval(int)
        //   else txs.data.push(row)
        // }, 30)
      }).finally(res => {
        this.loading=false
      })


      let year = (params.period+'').substr(0, 4)
      setTimeout(() => {
        this.$http.get(`stats/${this.$store.company.id}/${year}`).then(res => {
          this.saldi = res.data
        })
      }, 100)
    },

    refreshLedgers() {
      this.$http.get('ledgers?company_id='+this.$store.company.id).then(res => {
        this.ledgers = res.data
      })
    },

    deleteTx(tx) {
      if (!confirm('Sicuri di voler eliminare questo movimento e tutte le sue registrazioni collegate?'))
        return

      this.$http.delete('transactions/'+tx.id).then(res => {
        this.$root.$emit('transactions')
      })
    },

    findLedger(regex) {
      return (this.ledgers.find(l => l.code.match(regex)) || {}).id
    },

    createCustom(type, form) {
      var casse = this.ledgers.filter(l => l.code.match(/^CAS/))
      var banche = this.ledgers.filter(l => l.code.match(/^B/))


      var cats = this.cats

      if (form && [cats['entrata-cassa'], cats['entrata-banca'], cats['uscita-cassa'], cats['uscita-banca']].includes(form.category)) {
        let new_casse = casse.concat(banche)
        let new_banche = banche.concat(casse)
        casse = new_casse
        banche = new_banche
      }

      if (!type && form) {
        // Try to find a matching category
        for (var t in cats) {
          if (form.category == cats[t]) {
            type = t
            break
          }
        }
        // Fallback edit
        if (!type) {
          // this.tx_form = form
          this.tx_form = form
          // console.log('cannot find "', form.category,'"')
          // alert('Questo movimento non è modificabile')
          return
        }
      }

      this.custom = {
        type,
        form: form || {
          category: cats[type],
          company_id: this.$store.company.id,
          lines: null,
          date: Date.today(),
        }
      }

      setTimeout(() => {
        try {
          console.log(this.$refs.custom_focus)
          this.$refs.custom_focus.querySelector('input').focus()
        } catch (e) {
          console.log(e)
        }
      }, 300)

      var setLines = (lines) => {
        console.log('a')
        if (this.custom.form.lines) {
          this.custom.form.lines.sort((a, b) => {
            return a.amount - b.amount
          })
          lines.forEach((l, i) => {
            this.custom.form.lines[i].select = l.select
            this.custom.form.lines[i].label = l.label
          })
          console.log(this.custom.form.lines)
        } else {
          this.custom.form.lines = lines
        }
        console.log('b')
      }

      console.log('c')
      switch (type) {
        case 'cassa-a-banca':
          setLines([
            { ledger_id: this.findLedger('CAS'), amount: 0, select: casse, label: 'Cassa' },
            { ledger_id: this.findLedger('B01'), amount: 0, select: banche, label: 'Banca' },
          ])
          break
        case 'banca-a-cassa':
          setLines([
            { ledger_id: this.findLedger('B01'), amount: 0, select: banche, label: 'Banca' },
            { ledger_id: this.findLedger('CAS'), amount: 0, select: casse, label: 'Cassa' },
          ])
          break
        case 'entrata-cassa':
          setLines([
            { select: this.ledgers, amount: 0, },
            { ledger_id: this.findLedger('CAS'), amount: 0, select: casse, label: 'Cassa' },
          ])
          break
        case 'entrata-banca':
          setLines([
            { select: this.ledgers, amount: 0, },
            { ledger_id: this.findLedger('B01'), amount: 0, select: banche, label: 'Banca' },
          ])
          break
        case 'uscita-cassa':
          setLines([
            { ledger_id: this.findLedger('CAS'), amount: 0, select: casse, label: 'Cassa' },
            { select: this.ledgers, amount: 0, },
          ])
          break
        case 'uscita-banca':
          setLines([
            { ledger_id: this.findLedger('B01'), amount: 0, select: banche, label: 'Banca' },
            { select: this.ledgers, amount: 0, },
          ])
          break
        case 'uso-buoni':
          setLines([
            { ledger_id: this.findLedger('144'), amount: 0, label: 'Buoni spesa' },
            { select: this.ledgers, amount: 0, },
          ])
          break
        default: throw new Exception('Tipo di movimento non lineato ' + type)
      }
    },

    saveCustom () {
      this.$refs.custom.validate(valid => {
        if (!valid) {
            return this.$Message.error('Controllare i campi')
        }


        var c = this.custom
        this.$set(c, 'saving', true)



        var cats = this.cats

        if ([cats['entrata-cassa'], cats['entrata-banca']].includes(c.form.category)) {
          let sel = this.ledgers.find(l => l.id == (c.form.lines[1] || {}).ledger_id)
          if (sel) {
            c.form.category = cats['entrata-' + (sel.code.startsWith('CAS') ? 'cassa' : 'banca')]
          }
        }
        if ([cats['uscita-cassa'], cats['uscita-banca']].includes(c.form.category)) {
          let sel = this.ledgers.find(l => l.id == (c.form.lines[0] || {}).ledger_id)
          if (sel) {
            c.form.category = cats['uscita-' + (sel.code.startsWith('CAS') ? 'cassa' : 'banca')]
          }
        }


        if (false && this.$store.company.has_iva) {
          console.log('has iva')

          var c40 = this.ledgers.find(l => l.code == 'C40')
          var c45 = this.ledgers.find(l => l.code == 'C45')
          var ide = this.ledgers.find(l => l.code == 'IDE')
          var ind = this.ledgers.find(l => l.code == 'IND')

          if (c40 && c45 && ide && ind) {
            var magic = {}
            magic[c40.id] ={
              imp: 10,
              detr: 50,
            }
            magic[c45.id] ={
              imp: 22,
              detr: 50,
            }

            c.form.lines.forEach(line => {
              var info = magic[line.ledger_id]
              console.log(_.cloneDeep(info), _.cloneDeep(line))
              if (info && line.amount < 0) {
                let imponibile = Math.round(line.amount / (100+info.imp) * 100 * 100) / 100
                let tot_iva = line.amount - imponibile
                let detraibile = Math.round(tot_iva / 100 * info.detr * 100) / 100
                let indetraibile = tot_iva - detraibile
                line.amount = imponibile
                c.form.lines.push({
                  ledger_id: ide.id,
                  amount: detraibile,
                })
                c.form.lines.push({
                  ledger_id: ind.id,
                  amount: indetraibile,
                })
              }
            })
            console.log('check completed')
          }
        }

        console.log('posting')
        this.$http.post('transactions', c.form).then(res => {
          this.custom = null
          this.$root.$emit('transactions')
        }).finally(res => {c.saving = false})
      })
    },

    orderBy(by) {
      var asc = false
      if (this.order && this.order.by == by) {
        asc = !this.order.asc
      }
      this.order = { by, asc }

      this.refreshTxs()
    },
    downloadTo(filename) {
      this._download = filename
      this.refreshTxs()
    },
  },

  computed: {
    show_tx_form: {
      get() {
        let ret = !!this.tx_form
        !ret && setTimeout(()=>{
          console.log('setting auto')
          document.body.style.overflow='auto'
        }, 2000)
        return ret
      },
      set(val) {
        if (!val) {
          this.tx_form = null
        }
      }
    },
    show_custom: {
      get() {
        let ret = !!this.custom
        !ret && setTimeout(()=>{
          console.log('setting auto')
          document.body.style.overflow='auto'
        }, 2000)
        return ret
      },
      set(val) {
        if (!val) {
          this.custom = null
        }
      }
    },
    cfl () {
      return this.custom.form.lines
    },
    cur_page () {
      return this.txs.data
      console.log('page')
      return this.txs.data && this.txs.data.slice(this.internal_page*30, (this.internal_page+1)*30)
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.page = null
        this.refreshTxs()
      }, 300)
    }
  }
}
</script>

<style lang="scss">

</style>
